import { defineMessages, FormattedMessage } from 'react-intl'

const messages = defineMessages({
  failed: {
    id: 'order.failed.screen.failed',
    defaultMessage: 'Order Failed',
  },
  orderFailed: {
    id: 'order.failed.screen.orderFailed',
    defaultMessage: `Your payment has failed due to 3D Secure authentication. Please try again or if you are seeing this message more than once, please contact your Bank for more information and support`,
  },
})

export default function CheckoutFailed() {
  return (
    <div className='congrats shadow-block'>
      <h2>
        <FormattedMessage {...messages.failed} />
      </h2>
      <p className='mtm'>
        <FormattedMessage
          {...messages.orderFailed}
          values={{
            a: (chunks) => <a href='mailto:travel@padi.com'>{chunks}</a>,
          }}
        />
      </p>
    </div>
  )
}
